import { useState } from 'react';

export type PageInClass = 'cp-page-in-a' | 'cp-page-in-b';

/**
 * The class that fades a page in, for the shell's <main>.
 *
 * The two classes run the same fade (index.css, "Loading animations"). It answers with
 * one, then the other, each time the path changes, because a CSS animation only starts
 * again when its name changes. That restarts the fade WITHOUT remounting anything: a key
 * on <main>, or a wrapper round the page, would throw away what the page has loaded.
 *
 * The fade is opacity only, and leaves nothing behind when it ends. A transform on
 * <main> would make it the frame every fixed-position pop-up in a page is placed in, and
 * an animation that kept its last frame would leave <main> a layer of its own for good.
 */
export function usePageInClass(pathname: string): PageInClass {
  const [seen, setSeen] = useState<{ pathname: string; fade: PageInClass }>({ pathname, fade: 'cp-page-in-a' });
  if (seen.pathname === pathname) return seen.fade;
  // The path has changed: take the other class, in this same render.
  const fade: PageInClass = seen.fade === 'cp-page-in-a' ? 'cp-page-in-b' : 'cp-page-in-a';
  setSeen({ pathname, fade });
  return fade;
}
